var sec = 10799;
var timerEl = document.getElementById('timer');
if (timerEl) {
  function tick() {
    var h = String(Math.floor(sec / 3600)).padStart(2, '0');
    var m = String(Math.floor((sec % 3600) / 60)).padStart(2, '0');
    var s = String(sec % 60).padStart(2, '0');
    timerEl.textContent = h + ':' + m + ':' + s;
    if (sec > 0) sec--;
  }
  tick();
  setInterval(tick, 1000);
}
var navToggle = document.getElementById('nav-toggle');
var mobilePanel = document.getElementById('mobile-panel');
var navOpen = false;
if (navToggle && mobilePanel) {
  navToggle.onclick = function () {
    navOpen = !navOpen;
    mobilePanel.classList.toggle('hidden', !navOpen);
    navToggle.innerHTML = navOpen ? '<i class="fas fa-xmark"></i>' : '<i class="fas fa-bars"></i>';
  };
  mobilePanel.querySelectorAll('a').forEach(function (a) {
    a.onclick = function () {
      navOpen = false;
      mobilePanel.classList.add('hidden');
      navToggle.innerHTML = '<i class="fas fa-bars"></i>';
    };
  });
}
var floatBtn = document.getElementById('float-btn');
if (floatBtn) {
  window.addEventListener('scroll', function () {
    floatBtn.classList.toggle('opacity-0', window.scrollY <= 700);
    floatBtn.classList.toggle('pointer-events-none', window.scrollY <= 700);
  });
}
var popups = [1, 2, 3];
var pIdx = 0,
  activeP = null;

function showPopup(id) {
  var el = document.getElementById('popup-' + id);
  if (!el) return;
  el.classList.remove('opacity-0', 'pointer-events-none');
  el.classList.add('fade-up');
  activeP = id;
  setTimeout(function () {
    closePopup(id);
  }, 5500);
}

function closePopup(id) {
  var el = document.getElementById('popup-' + id);
  if (!el) return;
  el.classList.add('opacity-0', 'pointer-events-none');
  el.classList.remove('fade-up');
  if (activeP === id) activeP = null;
}

function cycle() {
  if (activeP !== null) return;
  showPopup(popups[pIdx]);
  pIdx = (pIdx + 1) % popups.length;
}
setTimeout(function () {
  cycle();
  setInterval(cycle, 36000);
}, 25000);
var currentSlide = 0;
var sliderTrack = document.getElementById('slider-track');
var slides = sliderTrack ? sliderTrack.querySelectorAll('img') : [];
var totalSlides = slides.length;
var galleryDots = document.querySelectorAll('.gallery-dot');
var imageSrcs = Array.from(slides).map(function (img) {
  return img.src;
});

function updateSlider() {
  if (!sliderTrack) return;
  sliderTrack.style.transform = 'translateX(-' + (currentSlide * 100) + '%)';
  galleryDots.forEach(function (dot, i) {
    dot.classList.toggle('bg-base-100', i === currentSlide);
    dot.classList.toggle('bg-base-500', i !== currentSlide);
  });
}

function slideGallery(dir) {
  if (!totalSlides) return;
  currentSlide = (currentSlide + dir + totalSlides) % totalSlides;
  updateSlider();
}

function goToSlide(index) {
  currentSlide = index;
  updateSlider();
}
var lightboxIndex = 0;
var lightbox = document.getElementById('lightbox');
var lightboxImg = document.getElementById('lightbox-img');
var lightboxCounter = document.getElementById('lightbox-counter');

function openLightbox(index) {
  if (!lightbox) return;
  lightboxIndex = index;
  updateLightbox();
  lightbox.classList.remove('hidden');
  document.body.style.overflow = 'hidden';
}

function closeLightbox(e) {
  if (!lightbox) return;
  if (e && e.target !== lightbox) return;
  lightbox.classList.add('hidden');
  document.body.style.overflow = '';
}

function lightboxNav(dir) {
  if (!totalSlides) return;
  lightboxIndex = (lightboxIndex + dir + totalSlides) % totalSlides;
  updateLightbox();
}

function updateLightbox() {
  if (!lightboxImg || !lightboxCounter) return;
  lightboxImg.src = imageSrcs[lightboxIndex];
  lightboxCounter.textContent = (lightboxIndex + 1) + ' / ' + totalSlides;
}
var reviewImgs = document.querySelectorAll('.review-img');
var reviewLightbox = document.getElementById('review-lightbox');
var reviewLbImg = document.getElementById('review-lb-img');
var reviewLbUser = document.getElementById('review-lb-user');
var reviewLbStars = document.getElementById('review-lb-stars');
var reviewLbCounter = document.getElementById('review-lb-counter');
var reviewLbIdx = 0;

function openReviewLb(index) {
  if (!reviewLightbox) return;
  reviewLbIdx = index;
  updateReviewLb();
  reviewLightbox.classList.remove('hidden');
  document.body.style.overflow = 'hidden';
}

function closeReviewLb(e) {
  if (!reviewLightbox) return;
  if (e && e.target !== reviewLightbox) return;
  reviewLightbox.classList.add('hidden');
  document.body.style.overflow = '';
}

function updateReviewLb() {
  var img = reviewImgs[reviewLbIdx];
  if (!img || !reviewLbImg || !reviewLbUser || !reviewLbStars || !reviewLbCounter) return;
  reviewLbImg.src = img.src;
  reviewLbUser.textContent = img.dataset.user;
  var rating = parseInt(img.dataset.rating);
  reviewLbStars.innerHTML = Array(5).fill(0).map(function (_, i) {
    return '<i class="fa-' + (i < rating ? 'solid' : 'regular') + ' fa-star"></i>';
  }).join('');
  reviewLbCounter.textContent = (reviewLbIdx + 1) + ' / ' + reviewImgs.length;
}

function reviewLbNext() {
  if (!reviewImgs.length) return;
  reviewLbIdx = (reviewLbIdx + 1) % reviewImgs.length;
  updateReviewLb();
}

function reviewLbPrev() {
  if (!reviewImgs.length) return;
  reviewLbIdx = (reviewLbIdx - 1 + reviewImgs.length) % reviewImgs.length;
  updateReviewLb();
}
var offerSeconds = 10799;
var offerCountdownEl = document.getElementById('offer-countdown');
if (offerCountdownEl) {
  function tickOfferTimer() {
    var h = String(Math.floor(offerSeconds / 3600)).padStart(2, '0');
    var m = String(Math.floor((offerSeconds % 3600) / 60)).padStart(2, '0');
    var s = String(offerSeconds % 60).padStart(2, '0');
    offerCountdownEl.textContent = h + ':' + m + ':' + s;
    if (offerSeconds > 0) offerSeconds--;
  }
  tickOfferTimer();
  setInterval(tickOfferTimer, 1000);
}

function toggleFaq(btn) {
  var item = btn.closest('.faq-item');
  var content = item.querySelector('.faq-content');
  var isActive = item.classList.contains('active');
  document.querySelectorAll('.faq-item').forEach(function (el) {
    el.classList.remove('active');
    el.querySelector('.faq-content').classList.add('hidden');
  });
  if (!isActive) {
    item.classList.add('active');
    content.classList.remove('hidden');
  }
}

function openModal(id) {
  var el = document.getElementById('modal-' + id);
  if (!el) return;
  el.classList.remove('hidden');
  document.body.style.overflow = 'hidden';
}

function closeModal(id) {
  var el = document.getElementById('modal-' + id);
  if (!el) return;
  el.classList.add('hidden');
  document.body.style.overflow = '';
}
var exitShown = false;
var timeOnPage = 0;
var scrollDepth = 0;
setInterval(function () {
  timeOnPage++;
}, 1000);
window.addEventListener('scroll', function () {
  var docHeight = document.documentElement.scrollHeight - window.innerHeight;
  scrollDepth = Math.max(scrollDepth, Math.round((window.scrollY / docHeight) * 100));
});
document.addEventListener('mouseout', function (e) {
  if (e.clientY < 10 && !exitShown && timeOnPage >= 25 && scrollDepth >= 30) {
    var exitPopup = document.getElementById('exit-popup');
    if (exitPopup) {
      exitPopup.classList.remove('hidden');
      document.body.style.overflow = 'hidden';
      exitShown = true;
    }
  }
});

function closeExitPopup() {
  var exitPopup = document.getElementById('exit-popup');
  if (exitPopup) exitPopup.classList.add('hidden');
  document.body.style.overflow = '';
}

function showExitStep(step) {
  document.querySelectorAll('[id^="exit-step-"]').forEach(function (el) {
    el.classList.add('hidden');
  });
  var stepEl = document.getElementById('exit-step-' + step);
  if (stepEl) stepEl.classList.remove('hidden');
}

function handleExitEmail(e) {
  if (e) e.preventDefault();
  var exitEmailEl = document.getElementById('exit-email');
  if (!exitEmailEl) return;
  var email = exitEmailEl.value;
  if (email) {
    collectCustomer(email);
    showExitStep(3);
  }
}

function copyCoupon() {
  var display = document.getElementById('coupon-display');
  var btn = document.getElementById('copy-btn');
  if (!display || !btn) return;
  navigator.clipboard.writeText(display.textContent);
  btn.innerHTML = '<i class="fas fa-check mr-2"></i>Copied!';
  setTimeout(function () {
    btn.innerHTML = '<i class="fas fa-copy mr-2"></i>Copy Code';
  }, 2000);
}
document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') {
    closeExitPopup();
    if (lightbox && !lightbox.classList.contains('hidden')) closeLightbox();
    if (reviewLightbox && !reviewLightbox.classList.contains('hidden')) closeReviewLb();
    document.querySelectorAll('.modal-overlay').forEach(function (m) {
      var id = m.id.replace('modal-', '');
      closeModal(id);
    });
  }
  if (lightbox && !lightbox.classList.contains('hidden')) {
    if (e.key === 'ArrowLeft') lightboxNav(-1);
    if (e.key === 'ArrowRight') lightboxNav(1);
  }
  if (reviewLightbox && !reviewLightbox.classList.contains('hidden')) {
    if (e.key === 'ArrowRight') reviewLbNext();
    if (e.key === 'ArrowLeft') reviewLbPrev();
  }
});
var touchStartX = 0;
if (sliderTrack) {
  sliderTrack.addEventListener('touchstart', function (e) {
    touchStartX = e.touches[0].clientX;
  });
  sliderTrack.addEventListener('touchend', function (e) {
    var diff = touchStartX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) slideGallery(diff > 0 ? 1 : -1);
  });
}

function collectCustomer(email) {
  var currentUrl = window.location.href;
  var product_name = (window.static_product_data && window.static_product_data.product_name) ? window.static_product_data.product_name : "YourProductName";
  var productImage = document.querySelector(".variant-image") ? document.querySelector(".variant-image").getAttribute("src") : "";
  fetch("/collect-customer", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      email: email,
      currentUrl: currentUrl,
      product_name: product_name,
      productImage: productImage
    })
  });
}
